import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=500f9c4c&"
import script from "./DeleteBtn.vue?vue&type=script&lang=ts&"
export * from "./DeleteBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports